import { HttpContextToken } from '@angular/common/http';

/** Prevents infinite refresh→401→refresh loops on the retried request. */
export const AUTH_REFRESH_RETRIED = new HttpContextToken<boolean>(() => false);
